// Redirect script
const dropdown = document.getElementById("redirect-dropdown");
const options = document.getElementById("redirect-dropdown-options");
const selectedOption = document.getElementById("selected-option");
const customOptions = document.querySelectorAll(".redirect-dropdown-option");
let map;
let currentMarkers = [];

dropdown.addEventListener("click", function () {
  options.classList.toggle("open");
});

customOptions.forEach((option) => {
  option.addEventListener("click", function () {
    selectedOption.textContent = this.textContent;
    const value = this.getAttribute("data-value");
    // Redirects the user based on the
    let redirectUrl = "/";
    switch (value) {
      case "practitioner":
        redirectUrl = "/pages/find-a-practitioner";
        break;
      case "course":
        redirectUrl = "/pages/find-a-certification-course";
        break;
    }

    window.location.href = redirectUrl;
    dropdown.classList.remove("open");
    options.classList.remove("open");
  });
});

// Close dropdown when clicking outside
document.addEventListener("click", function (event) {
  if (!dropdown.contains(event.target) && !options.contains(event.target)) {
    dropdown.classList.remove("open");
    options.classList.remove("open");
  }
});

// Retrieve the users current location
document
  .querySelector(".current-location")
  .addEventListener("click", function () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          // Save to the window object
          window.user_location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            timestamp: position.timestamp,
          };

          // Clear the input
          const geocodeInput = document.getElementById("geolocation-input");
          geocodeInput.value = "";

          loadFacilities({
            location: "",
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });

          map.setCenter({lat: position.coords.latitude, lng: position.coords.longitude});
          map.setZoom(10);
        },
        function (error) {
          let error_message = "Unable to retrieve your location";
          switch (error.code) {
            case error.PERMISSION_DENIED:
              error_message = "Location permission denied";
              break;
            case error.POSITION_UNAVAILABLE:
              error_message = "Location information is unavailable";
              break;
            case error.TIMEOUT:
              error_message = "Location request timed out";
              break;
          }
        }
      );
    } else {
      alert("Geolocation is not supported by your browser");
    }
  });

// Search the trainers by input
document
  .getElementById("geolocation-input")
  .addEventListener("keydown", async function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const location = this.value.trim();
      if (location) {
        // First, try to geocode the location to get coordinates
        const geocoder = new google.maps.Geocoder();
        try {
          const response = await new Promise((resolve, reject) => {
            geocoder.geocode({ address: location }, (results, status) => {
              if (status === 'OK' && results[0]) {
                resolve(results[0]);
              } else {
                reject(new Error('Location not found'));
              }
            });
          });

          // Get the location coordinates
          const location_pos = response.geometry.location;

          // Center the map on the searched location
          map.setCenter(location_pos);
          map.setZoom(10);

          // Load practitioners near this location
          loadFacilities({
            location: location,
            lat: location_pos.lat(),
            lng: location_pos.lng(),
            use_bounds: true
          });

        } catch (error) {
          console.error("Error geocoding location:", error);
          // Fallback to just searching by location name if geocoding fails
          loadFacilities({
            location: location,
            use_bounds: true
          });
        }
      }
    }
  });


// Only load Google Maps API if not already loaded
if (!window.google || !window.google.maps) {
  window.initMap = function () {
    map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 9.0820, lng: 8.6753 }, // Nigeria
      zoom: 2,
      mapId: "9a29aa3d50d50c50944584f5",
      disableDefaultUI: true,
    });

    checkGeolocationAndloadFacilities();
  };

  const script = document.createElement("script");
  script.src =
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyDaQEM7Wfy9rZtOet2e_VhtgVcCkkTN3Ls&libraries=maps,marker&callback=initMap";
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
} else {
  // Already loaded? Just init it.
  window.initMap();
  checkGeolocationAndloadFacilities();
}

// Async call to practitioners API
// Async call the practitioners API
async function loadFacilities({
                                   location = "",
                                   lat = null,
                                   lng = null,
                                 } = {}) {
  // Display Loading Overlay
  const overlay = document.getElementById("global-loading-overlay");
  overlay.style.display = "flex";

  const isDesktop = window.innerWidth >= 1024;

  let apiUrl = "https://functionalpatterns.app/api/facilities-nearby?";

  // If there`s lat and lng
  if (lat !== null && lng !== null) {
    apiUrl += `latitude=${encodeURIComponent(lat)}&longitude=${encodeURIComponent(lng)}`;
    // If there`s location
  } else if (location) {
    apiUrl += `location=${encodeURIComponent(location)}`;
  } else {
    throw new Error("At least the location or lat/lng is required.");
  }

  // Set the count of slide changes
  let countSlideChanges = 0;

  try {
    // Clear the old markers for the map
    currentMarkers.forEach((marker) => marker.setMap(null));
    currentMarkers = [];

    const response = await fetch(apiUrl);
    if (!response.ok)
      throw new Error(`Error while fetching data: ${response.status}`);

    const practitioners = await response.json();

    const container = document.getElementById("practitioner-cards-container");
    container.innerHTML = "";

    // If there's no practitioners' we show a no result card and render the swiper with a single slide
    if (!practitioners.length) {
      container.innerHTML = `
        <div class="swiper-slide">
          <div class="no-results-card">
              <div class="no-result-img">
                <img src="https://cdn.shopify.com/s/files/1/0151/9191/files/no-location.png?v=1751811034" width="40" height="40" alt="No results" class="no-results-icon">
              </div>
              <div class="no-results-text">
                <h3 class="no-results-title">No facilities found</h3>
                <p class="no-results-description">Try searching again with a different City, Zip Code or enable your Current Location</p>
            </div>
          </div>
        </div>
      `;

      // If there`s a swiper created, destroy it
      if (window.practitionerSwiper) {
        window.practitionerSwiper.destroy(true, true);
      }

      // Delay to allow DOM to finish updating
      setTimeout(() => {
        window.practitionerSwiper = new Swiper(".practitioner-swiper", {
          loop: true,
          direction: isDesktop ? "vertical" : "horizontal",
          slidesPerView: 1,
          spaceBetween: 10,
          allowSlidePrev: true,
          allowSlideNext: true,
          mousewheel: isDesktop,
          speed: 600,
        });
      }, 100);
      return;
    }

    // For each practitioner
    practitioners.forEach((p) => {
      // Add pins to the map
      const {lat, lng} = p.position;

      // 1. Convert coordinates to float
      const originalLat = parseFloat(lat);
      const originalLng = parseFloat(lng);

      // 2. Add marker
      const marker = new google.maps.Marker({
        position: { lat: originalLat, lng: originalLng },
        map: map, // The map instance is injected
        title: p.name,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/0151/9191/files/Facilities_Pinpoint.png?v=1752427480",
          scaledSize: new google.maps.Size(42, 59),
        },
      });

      // 3.1. Store the slide index
      marker.__slideIndex = currentMarkers.length;

      marker.addListener("click", () => {
        if (window.practitionerSwiper) {
          // Lembrando: .slideTo() espera índice base 0, com offset se loop ativo
          const slideIndex = marker.__slideIndex;
          const isLoop = window.practitionerSwiper.params.loop;

          if (isLoop) {
            const realIndex = window.practitionerSwiper.realIndex;
            const totalSlides = practitioners.length;
            const diff = slideIndex - realIndex;

            window.practitionerSwiper.slideToLoop(slideIndex);
          } else {
            window.practitionerSwiper.slideTo(slideIndex);
          }
        }
      });

      // 3.2. Store the marker to update later
      currentMarkers.push(marker);

      // 4. Recreate the cards
      const card = document.createElement("div");
      card.className = "swiper-slide";
      // Add data attribute to identify this card's marker
      card.dataset.markerIndex = currentMarkers.length - 1;

      card.innerHTML = `
      <div class="practitioner-card">
          <div class="practitioner-image">
            <img src="${
        p.avatar?.thumbnail_url || "default-avatar.jpg"
      }" alt="${p.name}" width="140" height="140" />
          </div>
          <div class="practitioner-info">
            <h3 class="practitioner-name">${p.name.toUpperCase()}</h3>
            <p class="practitioner-location">Training out of ${p.location}</p>
            <button class="fill-form-btn" 
              data-name="${p.name}" 
              data-photo="${p.avatar?.thumbnail_url || "default-avatar.jpg"}" 
              data-location="${p.location}" data-email="${p.email}">FILL OUT FORM</button>
          </div>
      </div>
      `;

      // Add click handler to center the map on marker when the card is clicked
      card.addEventListener('click', function() {
        const markerIndex = parseInt(this.dataset.markerIndex);
        if (currentMarkers[markerIndex]) {
          const marker = currentMarkers[markerIndex];
          // Smooth pan to marker
          map.panTo(marker.getPosition());
          // Slight zoom in for better visibility
          map.setZoom(12);

          // Optional: Add a bounce animation to the marker
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => {
            marker.setAnimation(null);
          }, 1500);

          // Update the swiper to show this card as active
          if (window.practitionerSwiper) {

            // Update swiper to show this slide
            const slideIndex = marker.__slideIndex;
            if (window.practitionerSwiper.params.loop) {
              window.practitionerSwiper.slideToLoop(slideIndex);
            } else {
              window.practitionerSwiper.slideTo(slideIndex);
            }
          }
        }
      });

      container.appendChild(card);
    });

    // Destroy the previous swiper
    if (window.practitionerSwiper) {
      window.practitionerSwiper.destroy(true, true);
    }


    // Delay to allow DOM to finish updating
    setTimeout(() => {
      window.practitionerSwiper = new Swiper(".practitioner-swiper", {
        loop: true,
        direction: isDesktop ? "vertical" : "horizontal",
        slidesPerView: isDesktop ? 3 : 1,
        spaceBetween: 10,
        allowSlidePrev: true,
        allowSlideNext: true,
        mousewheel: isDesktop,
        speed: 600, // <- duration in ms, adjust for smoother transition
        on: {
          slideChange() {
            const realIndex = this.realIndex;

            // Prevent infinite loop
            if(countSlideChanges === 0) {
              countSlideChanges++;
              return;
            }

            // Access the marker for the current slide
            const marker = currentMarkers[realIndex];
            if (marker && marker.getPosition) {
              const targetPos = marker.getPosition();

              // Smooth pan
              map.panTo(targetPos);

              // Smooth zoom from current to 14
              const currentZoom = map.getZoom();
              const targetZoom = 10;
              smoothZoom(map, targetZoom, currentZoom);

              map.panBy(0, 40);

              // Optional: bring marker to front
              currentMarkers.forEach((m) => m.setZIndex(1));
              marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
            }
          },
        },
      });
    }, 100);
  } catch (error) {
    // 1. Display the error Swipe Card
    const container = document.getElementById("practitioner-cards-container");
    container.innerHTML = `
      <div class="swiper-slide">
        <div class="error-card">
          <div class="error-img">
            <img src="https://cdn.shopify.com/s/files/1/0151/9191/files/warning.png?v=1751814262" width="40" height="40" alt="No results" class="no-results-icon">
          </div>
          <div class="error-text">
            <h3 class="error-title">Oops! Something went wrong</h3>
            <p class="no-results-description">We couldn't load facilities right now. Please try again later or refresh the page</p>
          </div>
        </div>
      </div>`;

    // 2. Destroy the previous swiper
    if (window.practitionerSwiper) {
      window.practitionerSwiper.destroy(true, true);
    }

    // Delay to allow DOM to finish updating
    setTimeout(() => {
      window.practitionerSwiper = new Swiper(".practitioner-swiper", {
        loop: true,
        direction: isDesktop ? "vertical" : "horizontal",
        slidesPerView: 1,
        spaceBetween: 10,
        allowSlidePrev: true,
        allowSlideNext: true,
        mousewheel: isDesktop,
        speed: 600,
      });
    }, 100);
  } finally {
    overlay.style.display = "none"; // <- Hides the overlay after loading
  }
}

// This function will relocate the swiper based on the window size
function relocateSwiper() {
  const swiperContainer = document.querySelector(
    ".practitioner-swiper-container"
  );
  const placeholder = document.getElementById("swiper-desktop-placeholder");
  const mapWrapper = document.querySelector(".map-container");

  if (!swiperContainer || !placeholder || !mapWrapper) return;

  if (window.innerWidth >= 1024) {
    if (!placeholder.contains(swiperContainer)) {
      placeholder.appendChild(swiperContainer);
    }
  } else {
    if (!mapWrapper.contains(swiperContainer)) {
      mapWrapper.appendChild(swiperContainer);
    }
  }
}

// Calls the events when the DOMContentLoaded is triggered
window.addEventListener("DOMContentLoaded", relocateSwiper);
// Calls the events when the resize is triggered
window.addEventListener("resize", relocateSwiper);

// Opens the modal
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("fill-form-btn")) {
    e.preventDefault();
    const modal = document.getElementById("form-modal");
    const name = e.target.dataset.name;
    const photo = e.target.dataset.photo;
    const location = e.target.dataset.location;
    const email = e.target.dataset.email;

    // Preenche os campos do modal
    document.getElementById("modal-practitioner-name").textContent = name;
    document.getElementById("modal-practitioner-photo").src = photo;
    document.getElementById(
      "modal-practitioner-photo"
    ).alt = `Photo of ${name}`;
    document.getElementById(
      "modal-practitioner-location"
    ).textContent = `Training out of ${location}`;
    document.getElementById("modal-practitioner-cta").textContent = `Contact ${
      name.split(" ")[0]
    }`;
    let hiddenEmail = document.getElementById('hidden-1')
    hiddenEmail.value = email;

    modal.style.display = "flex";
  }
});

// Closes the modal
document
  .querySelector(".form-modal-close")
  .addEventListener("click", function () {
    const dismissButton = document.querySelector('#globo-formbuilder-126856 .message.success > .dismiss');
    console.log(dismissButton);
    if (dismissButton) dismissButton.click();

    document.getElementById("form-modal").style.display = "none";

  });

// Closes when clicking outside the modal
window.addEventListener("click", function (e) {
  const modal = document.getElementById("form-modal");
  if (e.target === modal) {

    const dismissButton = document.querySelector('#globo-formbuilder-126856 .message.success > .dismiss');
    if (dismissButton) dismissButton.click();
    modal.style.display = "none";
  }
});

/* Smooth zoom function */
function smoothZoom(map, targetZoom, currentZoom) {
  if (currentZoom === targetZoom) return;

  const nextZoom = currentZoom < targetZoom ? currentZoom + 1 : currentZoom - 1;

  map.setZoom(nextZoom);

  setTimeout(() => {
    smoothZoom(map, targetZoom, nextZoom);
  }, 80); // play with this timing for speed (60–100ms usually good)
}

// Function to check geolocation permissions and load practitioners accordingly
function checkGeolocationAndloadFacilities() {
  if (navigator.permissions) {
    navigator.permissions.query({name: 'geolocation'}).then(permissionStatus => {
      if (permissionStatus.state === 'granted') {
        // If permission was previously granted, get the current position
        navigator.geolocation.getCurrentPosition(
          position => {
            window.user_location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              timestamp: position.timestamp,
            };
            loadFacilities({
              location: "",
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          // If getting position fails, fall back to showing all practitioners
          () => loadFacilities({ lat: 9.0820, lng: 8.6753 }),
          {maximumAge: 300000, timeout: 10000, enableHighAccuracy: true}
        );
      } else {
        // If no permission was previously granted, show all practitioners
        loadFacilities({ lat: 9.0820, lng: 8.6753 });
      }
    });
  } else {
    // If the permissions API is not supported, default to showing all practitioners
    loadFacilities({ lat: 9.0820, lng: 8.6753 });
  }
}
